import { render, staticRenderFns } from "./OutgoingCard.vue?vue&type=template&id=456e0da1&scoped=true"
import script from "./OutgoingCard.vue?vue&type=script&lang=js"
export * from "./OutgoingCard.vue?vue&type=script&lang=js"
import style0 from "./OutgoingCard.vue?vue&type=style&index=0&id=456e0da1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e0da1",
  null
  
)

export default component.exports